import { TMapControllerSide } from '../types';

type TSmoothMoveOptions = Pick<YMaps.ISetBoundsOptions, 'duration' | 'timingFunction' | 'useMapMargin'>;

export function createSmoothMoveOptions(): TSmoothMoveOptions {
  return {
    duration: 250,
    timingFunction: 'ease-in-out',
    useMapMargin: true,
  };
}

export function buildAreaSpec(side: TMapControllerSide, width: number): YMaps.map.margin.IScreenArea {
  switch (side) {
    case 'left':
      return { top: 0, left: 0, width, height: '100%' };
  }
}

export function swallowRejection(promise: Promise<unknown> | undefined): void {
  if (!promise || typeof promise.then !== 'function') {
    return;
  }

  promise.then(
    () => undefined,
    () => undefined,
  );
}
